import React from 'react'
import { useSelector } from 'react-redux'

// Components
import { Avatar } from '../../..'

// Selectors
import { selectCustomerPhotoUri } from '../../../../store/selectors/customerProfile'
import { selectSponsorshipPhotoUri } from '../../../../store/selectors/sponsorship'

// Styles
import styles from './CospoIntro.module.scss'

const CospoAvatars = () => {
  const customerPhotoUri = useSelector(selectCustomerPhotoUri)
  const sponsorPhotoUri = useSelector(selectSponsorshipPhotoUri)

  return (
    <div className={styles.avatars}>
      <Avatar src={customerPhotoUri} className={styles.avatar} />
      <Avatar src={sponsorPhotoUri} className={styles.avatar} />
    </div>
  )
}

export default CospoAvatars
